import React, { useEffect } from "react";

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container mx-auto">
      <div className="flex flex-col gap-4 p-5">
        <p>
          Welcome to Tailtales, an innovative platform designed to revolutionize the dog adoption
          process by uniting dog shelters across Europe on a single digital platform.
        </p>
        <p>
          Our goal is to expand the reach of shelters, increase adoption opportunities, and
          simplify, secure, and enhance the entire experience for everyone involved.
        </p>
      </div>
    </div>
  );
}
